<template>
    <div class="scenarioCover" :style="{ 'background-image': `url(${bgComputed})` }">
        <TitleBlock
            :primaryTitle="primaryTitle"
            :primarySubtitle="primarySubtitle"
            :secondaryContent="secondaryContent"
            :buttonLabel="buttonLabel"
            @buttonPulseClick="$emit('deploy')"
        />    
    </div>
</template>

<script>
import TitleBlock from '@/components/TitleBlock'

export default {
    name: 'ScenarioSplashPage',
    components: {
        TitleBlock,
    },
    props: [
        'primaryTitle',
        'primarySubtitle',
        'secondaryContent',
        'buttonLabel',
        'buttonPulseClick',
        'bgImage',
    ],
    computed: {
        bgComputed() {
            return require( '@/assets/images/stage_backgrounds/' + this.bgImage );
        },
    },
}
</script>

<style lang="scss" scoped>
.scenarioCover {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: white;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    display: flex;
    align-items: center;
    justify-content: center;
}
</style>